import { Component, Input, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-grupa-form',
  templateUrl: './grupa-form.component.html',
  styleUrls: ['./grupa-form.component.scss']
})
export class GrupaFormComponent implements OnChanges {

    grupaForm: FormGroup;

    @Input()

    initialValue: any;

    constructor(private formBuilder: FormBuilder) {
        this.grupaForm = this.formBuilder.group({
            cena:               [],
            cena_jednostki:     [],
            do_kiedy:           [''],
            ilosc_godzin:       [],
            isArchiv:           [0],
            nazwa:              ['', Validators.required],
            od_kiedy:           [''],
            opis:               [''],
        });
    }

    ngOnChanges(changes) {
        if (changes.initialValue) {
            this.grupaForm.patchValue(changes.initialValue.currentValue);
        }
    }

    isErrorVisible(field: string, error: string) {
        return this.grupaForm.controls[field].dirty
            && this.grupaForm.controls[field].errors
            && this.grupaForm.controls[field].errors[error];
    }

    get value() {
        return this.grupaForm.value;
    }

    get valid() {
        return this.grupaForm.valid;
    }

    reset() {
        this.grupaForm.reset();
    }

}



// WEBPACK FOOTER //
// ./src/app/grupy/grupa-form/grupa-form.component.ts